
export default function StatsSection() {
  const stats = [
    { number: '$500M+', label: 'Funded in Loans', icon: 'ri-money-dollar-circle-line' },
    { number: '2,000+', label: 'Satisfied Clients', icon: 'ri-user-heart-line' },
    { number: '50+', label: 'Lending Partners', icon: 'ri-building-line' },
    { number: '24-48hr', label: 'Pre-Approval Time', icon: 'ri-timer-line' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
